import { useCallback } from 'react';
import gql from 'graphql-tag';

import { getApolloClient } from '@confluence/graphql';
import { getMonitoringClient } from '@confluence/monitoring';
import { Attribution } from '@confluence/error-boundary';

interface UseGetSpaceIdsFromSpaceKeysQueryVariables {
	spaceKeys?: (string | null)[] | null;
}
interface UseGetSpaceIdsFromSpaceKeysQueryResponse {
	spaces: {
		nodes:
			| {
					id: string | null;
			  }[]
			| null;
	} | null;
}

// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Read https://go/connie-relay-migration-fyi
const UseGetSpaceIdsFromSpaceKeysQuery = gql`
	query UseGetSpaceIdsFromSpaceKeysQuery($spaceKeys: [String]) {
		spaces(spaceKeys: $spaceKeys) {
			nodes {
				id
			}
		}
	}
`;

export const useGetSpaceIdsFromSpaceKeys = () => {
	const getSpaceIdsFromSpaceKeys = useCallback(async (spaceKeys: string[]): Promise<string[]> => {
		const apolloClient = getApolloClient();

		if (spaceKeys.length === 0) {
			return [];
		}

		try {
			const { data } = await apolloClient.query<
				UseGetSpaceIdsFromSpaceKeysQueryResponse,
				UseGetSpaceIdsFromSpaceKeysQueryVariables
			>({
				query: UseGetSpaceIdsFromSpaceKeysQuery,
				variables: { spaceKeys },
			});

			const spaceIds: string[] = (data.spaces?.nodes ?? [])
				.map((node) => node?.id)
				.filter((id): id is string => !!id);

			return spaceIds;
		} catch (error) {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.COMPANY_HUB,
			});
		}

		return [];
	}, []);

	return getSpaceIdsFromSpaceKeys;
};
